import React from 'react'
import { chevronLeft, chevronRight } from 'src/assets/png'
import { useStyles } from './styles'

interface PaginationProps {
  setCurrentPage: any
  pages: any
  totalItens?: any
  currentPage: any
}

export const Pagination: React.FC<PaginationProps> = ({ setCurrentPage, pages, totalItens, currentPage }) => {
  const style = useStyles()

  const nextPage = () => {
    if (currentPage < pages - 1) {
      setCurrentPage(currentPage + 1)
    }
  }

  const backPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1)
    }
  }

  const renderPageNumbers = () => {
    const pageNumbers: JSX.Element[] = []
    const maxPageButtons = 4

    let startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2))
    let endPage = Math.min(pages, startPage + maxPageButtons - 1)

    if (endPage - startPage < maxPageButtons - 1) {
      startPage = Math.max(1, endPage - maxPageButtons + 1)
    }

    if (startPage > 1) {
      pageNumbers.push(
        <button key={1} onClick={() => setCurrentPage(0)}>
          1
        </button>
      )
      if (startPage > 2) {
        pageNumbers.push(
          <button key='ellipsis-start' className='pagination__ellipsis' disabled>
            <svg width='12' height='20' viewBox='0 0 12 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M7.1998 10C7.1998 10.6914 6.66355 11.25 5.9998 11.25C5.33605 11.25 4.7998 10.6914 4.7998 10C4.7998 9.30859 5.33605 8.75 5.9998 8.75C6.66355 8.75 7.1998 9.30859 7.1998 10ZM10.4998 8.75C9.83605 8.75 9.2998 9.30859 9.2998 10C9.2998 10.6914 9.83605 11.25 10.4998 11.25C11.1636 11.25 11.6998 10.6914 11.6998 10C11.6998 9.30859 11.1636 8.75 10.4998 8.75ZM1.4998 8.75C0.836055 8.75 0.299805 9.30859 0.299805 10C0.299805 10.6914 0.836055 11.25 1.4998 11.25C2.16355 11.25 2.6998 10.6914 2.6998 10C2.6998 9.30859 2.16355 8.75 1.4998 8.75Z'
                fill='#7E4534'
              />
            </svg>
          </button>
        )
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          className={i === currentPage + 1 ? 'pagination__current-button' : ''}
          onClick={() => setCurrentPage(i - 1)}
        >
          {i}
        </button>
      )
    }

    if (endPage < pages) {
      if (endPage < pages - 1) {
        pageNumbers.push(
          <button key='ellipsis-end' className='pagination__ellipsis' disabled>
            <svg width='12' height='20' viewBox='0 0 12 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M7.1998 10C7.1998 10.6914 6.66355 11.25 5.9998 11.25C5.33605 11.25 4.7998 10.6914 4.7998 10C4.7998 9.30859 5.33605 8.75 5.9998 8.75C6.66355 8.75 7.1998 9.30859 7.1998 10ZM10.4998 8.75C9.83605 8.75 9.2998 9.30859 9.2998 10C9.2998 10.6914 9.83605 11.25 10.4998 11.25C11.1636 11.25 11.6998 10.6914 11.6998 10C11.6998 9.30859 11.1636 8.75 10.4998 8.75ZM1.4998 8.75C0.836055 8.75 0.299805 9.30859 0.299805 10C0.299805 10.6914 0.836055 11.25 1.4998 11.25C2.16355 11.25 2.6998 10.6914 2.6998 10C2.6998 9.30859 2.16355 8.75 1.4998 8.75Z'
                fill='#7E4534'
              />
            </svg>
          </button>
        )
      }

      // Adiciona última página (agora com clique funcionando)
      pageNumbers.push(
        <button
          key={pages}
          onClick={() => setCurrentPage(pages - 1)}
          className={currentPage === pages - 1 ? 'pagination__current-button' : ''}
        >
          {pages}
        </button>
      )
    }

    return pageNumbers
  }

  return (
    <div className={style.paginationWrapper}>
      {totalItens && <p>{totalItens} Registros encontrados</p>}
      {pages > 1 && (
        <div>
          <button onClick={backPage} disabled={currentPage === 0}>
            <img src={chevronRight} alt='Anterior' />
          </button>
          {renderPageNumbers()}
          <button onClick={nextPage} disabled={currentPage === pages - 1}>
            <img src={chevronLeft} alt='Próximo' />
          </button>
        </div>
      )}
    </div>
  )
}
